import cl from 'classnames'
import styles from './Modal.module.scss'
import { Modal as ModalComponent, ModalBackButton } from '@/components/Modal'
import React from 'react'

export const Modal = ({onClose, children}) => {
	return (
		<ModalComponent windowClassName={cl(styles.modal_wrapper, styles.modal_wrapper__send)}>
			<ModalBackButton onClick={onClose} />

			<div className={cl(styles.wrapper, 'scroll')}>
				{children}
			</div>
		</ModalComponent>
	)
}